import { Box, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import TitulosSelecionados from "../TitulosSelecionados";
import RegistrarPagamento from "./FinalizacaoOptions/RegistrarPagamento";
import Compensasao from "./FinalizacaoOptions/Compensasao";
import PagamentoRegistrado from "./PagamentoRegistrado";
import { ModalDetalheTituloPagarProvider } from "../../../ModalDetalheTituloContext";

export default function Step03() {

  const { watch } = useFormContext();

  const formRecb = watch('dados_pagamento.forma_pagamento')
  const pagamentoRegistrado = watch('pagamentoRegistrado')

  return (
    <>
      {
        !pagamentoRegistrado &&
        <Grid container minHeight={400} paddingTop={3} spacing={2} position="relative">
          <Grid size={{xs: 12, md: 6}} order={{ xs: 2, md: 1 }} >
            {
              formRecb === 'registrar pagamento' &&
              <RegistrarPagamento />
            }
            {
              formRecb === 'compensacao' &&
              <Compensasao />
            }
          </Grid>

          <Grid size={{xs: 12, md: 6}} order={{ xs: 1, md: 2 }}>
            <Box display="flex" justifyContent="flex-end">
              <TitulosSelecionados />
            </Box>
          </Grid>
        </Grid>
      }

      {
        pagamentoRegistrado &&
        <ModalDetalheTituloPagarProvider>
          <PagamentoRegistrado
            temRecibo={formRecb === 'registrar pagamento'? false: true}
          />
        </ModalDetalheTituloPagarProvider>
      }
    </>
  )
}
